/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
   /**
    * Service to retrieve privileges.
    */
   angular.module('com.vmware.platform.ui').factory('userPrivilegeService', ['dataService', 'defaultUriSchemeUtil',
      function (dataService, defaultUriSchemeUtil) {
         return {
            checkUserPrivilege: checkUserPrivilege
         };

         function checkUserPrivilege(object, privilege) {
            var objectId;
            if (typeof object === 'object') {
               objectId = defaultUriSchemeUtil.getVsphereObjectId(object);
            } else {
               objectId = object;
            }

             var options = {
                 propertyParams: [{
                     _type: "com.vmware.vise.mvc.model.data.ParamSpec",
                     propertyName: "hasPrivileges",
                     parameterType: "[Ljava.lang.String;",
                     parameter: [privilege]
                 }]
             };

            return dataService.getProperties(objectId, ['hasPrivileges'], options)
                  .then(function (data) {
                     return data && !!data.hasPrivileges;
                  });
         }
      }
   ]);
})();
